import { TextBox } from 'devextreme-react/text-box';

const FIELD_LABEL_STYLE = { display: 'block', fontSize: '12px', marginBottom: '2px', color: '#555' };

const GRID_STYLE = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' };

/**
 * The two fields a brand-new contact needs. Shared by the "Add new contact" flows on the company
 * edit form and the estimate's contacts grid, so both ask for the same thing the same way (WK-565).
 *
 * Everything else about a contact — job title, role, phones, emails — is edited after it exists.
 *
 * @param {string} firstName
 * @param {string} lastName
 * @param {Function} onChange - (field, value) => void, field being 'firstName' | 'lastName'
 */
export function NewContactNameFields({ firstName, lastName, onChange }) {
  return (
    <div style={GRID_STYLE}>
      <div>
        <label style={FIELD_LABEL_STYLE}>First Name *</label>
        <TextBox
          value={firstName}
          onValueChanged={(e) => onChange('firstName', e.value)}
          placeholder="First name"
          valueChangeEvent="input"
        />
      </div>
      <div>
        <label style={FIELD_LABEL_STYLE}>Last Name *</label>
        <TextBox
          value={lastName}
          onValueChanged={(e) => onChange('lastName', e.value)}
          placeholder="Last name"
          valueChangeEvent="input"
        />
      </div>
    </div>
  );
}
